import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HardHat, ClipboardList, Users, Home } from "lucide-react";

/**
 * Gedeelde publieke navigatiebalk met links naar Opdrachten (blauw) en
 * Beschikbare monteurs (groen). `active` = "opdrachten" | "monteurs" | null.
 */
export function PublicNav({ active = null }) {
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="nav-logo">
          <div className="w-9 h-9 bg-orange-500 flex items-center justify-center rounded-sm">
            <HardHat className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight hidden sm:inline">Work4you</span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          <Link to="/" data-testid="nav-home-link">
            <Button variant="ghost" className="rounded-sm font-semibold gap-2 text-slate-700 hover:text-orange-600">
              <Home className="w-4 h-4" />
              <span className="hidden sm:inline">Home</span>
            </Button>
          </Link>
          <Link to="/opdrachten" data-testid="nav-opdrachten-link">
            <Button variant="ghost"
              className={`rounded-sm font-semibold gap-2 ${active === "opdrachten" ? "text-blue-700 bg-blue-50 hover:bg-blue-100 hover:text-blue-800" : "text-slate-700 hover:text-blue-700"}`}>
              <ClipboardList className="w-4 h-4" />
              <span className="hidden xs:inline sm:inline">Opdrachten</span>
            </Button>
          </Link>
          <Link to="/beschikbare_monteurs" data-testid="nav-monteurs-link">
            <Button variant="ghost"
              className={`rounded-sm font-semibold gap-2 ${active === "monteurs" ? "text-emerald-700 bg-emerald-50 hover:bg-emerald-100 hover:text-emerald-800" : "text-slate-700 hover:text-emerald-700"}`}>
              <Users className="w-4 h-4" />
              <span className="hidden xs:inline sm:inline">Professionals</span>
            </Button>
          </Link>

          <span className="w-px h-6 bg-slate-200 mx-1 hidden sm:inline-block" />

          <Link to="/inloggen" data-testid="nav-login-link">
            <Button variant="ghost" className="rounded-sm font-semibold">Inloggen</Button>
          </Link>
          <Link to="/registreren" data-testid="nav-register-link">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-semibold">Aanmelden</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
